import React, { useState } from "react";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";

const ContactUs = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    const formData = new FormData(e.target);
    formData.append("access_key", "ac2e9cee-6cba-4036-ba57-56c081ef5ea8");
    formData.append("subject", "New Contact Inquiry - Wedding Stays");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.success) {
        setMessage("Thank you! We will contact you shortly 💍");
        e.target.reset();
      } else {
        setMessage("Something went wrong ❌");
      }
    } catch (error) {
      setMessage("Submission failed ❌");
    }

    setLoading(false);
  };

  return (
    <section className="bg-gradient-to-b from-[#fdf7f7] to-white py-20 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-serif text-[#b76d68] mb-4">
            Let’s Plan Your Perfect Wedding Stay
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Have questions about guest accommodation or destination wedding
            planning? Our team is here to help you every step of the way.
          </p>
        </div>

        {/* Main Grid */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Image */}
          <div className="flex justify-center">
            <img
              src="https://images.unsplash.com/photo-1765854634841-48f942e71047?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w4NDk1NzN8MHwxfHNlYXJjaHw2fHx3ZWRkaW5nJTIwYmFubmVyfGVufDB8fHx8MTc3MTA1NTg0MHww&ixlib=rb-4.1.0&q=80&w=400"
              alt="Wedding"
              className="rounded-2xl shadow-2xl w-[90%] object-cover"
            />
          </div>

          {/* Contact Form */}
          <div className="bg-white p-10 rounded-3xl shadow-2xl border border-gray-100">
            <h3 className="text-2xl font-semibold mb-6 text-gray-800">
              Get In Touch
            </h3>

            <form onSubmit={handleSubmit} className="space-y-5">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                required
                className="w-full rounded-xl border border-gray-300 px-4 py-3 focus:ring-2 focus:ring-[#b76d68] outline-none transition"
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                required
                className="w-full rounded-xl border border-gray-300 px-4 py-3 focus:ring-2 focus:ring-[#b76d68] outline-none transition"
              />

              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                required
                className="w-full rounded-xl border border-gray-300 px-4 py-3 focus:ring-2 focus:ring-[#b76d68] outline-none transition"
              />

              <textarea
                rows="4"
                name="message"
                placeholder="Your Message"
                required
                className="w-full rounded-xl border border-gray-300 px-4 py-3 focus:ring-2 focus:ring-[#b76d68] outline-none transition"
              ></textarea>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-[#b76d68] hover:bg-[#a85c58] text-white py-3 rounded-xl font-medium transition duration-300 shadow-lg disabled:opacity-60"
              >
                {loading ? "Sending..." : "Send Message"}
              </button>

              {message && (
                <p className="text-center mt-4 text-green-600 font-medium">
                  {message}
                </p>
              )}
            </form>
          </div>
        </div>

        {/* Contact Info Cards */}
        <div className="grid md:grid-cols-3 gap-8 mt-20">
          <div className="bg-white rounded-2xl shadow-md p-8 text-center hover:shadow-xl transition">
            <FaEnvelope className="text-[#b76d68] text-3xl mx-auto mb-4" />
            <a
              href="mailto:admin@jodisure.com"
              className="text-gray-700 hover:text-[#b76d68] transition duration-300"
            >
              info@weddingstays.com
            </a>
          </div>

          <div className="bg-white rounded-2xl shadow-md p-8 text-center hover:shadow-xl transition">
            <FaPhoneAlt className="text-[#b76d68] text-3xl mx-auto mb-4" />
            <p className="text-gray-700">+91 9883218266</p>
          </div>

          <div className="bg-white rounded-2xl shadow-md p-8 text-center hover:shadow-xl transition">
            <FaMapMarkerAlt className="text-[#b76d68] text-3xl mx-auto mb-4" />
            <p className="text-gray-700">
              6, Little Russel St, Kankaria Estates, Park Street area, Kolkata,
              West Bengal 700071
            </p>
          </div>
        </div>

        {/* Google Map */}
        <div className="mt-20 rounded-3xl overflow-hidden shadow-2xl">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.8186943396313!2d88.3507341!3d22.548463499999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a027710fe7094cb%3A0xefcbdbde655df7bd!2s6%2C%20Little%20Russel%20St%2C%20Kankaria%20Estates%2C%20Park%20Street%20area%2C%20Kolkata%2C%20West%20Bengal%20700071!5e0!3m2!1sen!2sin!4v1729073713648!5m2!1sen!2sin"
            width="100%"
            height="400"
            loading="lazy"
            className="border-0"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
